/** Chemin public de la liste des publications (évite « librairie » dans l’URL). */
export const PUBLIC_LIBRARY_PATH = '/bibliotheque';
